import React, {h, Component} from 'preact';

export default class SellPriceRangeStep extends Component {
    constructor(props) {
        super(props);

        let priceRanges = [...(this.props.parent.state.priceRanges || [])];
        priceRanges.reverse();

        this.state = {
            priceRanges: priceRanges
        };
    }

    componentDidMount() {
        trackEvent('Flow', 'SellRequest', 'sellV3Step1', {
            homeType: this.props.parent?.state?.homeType || ''
        })
            .withGA()
            .withOptimizely();

        trackEvent('Flow', 'SellRequest', 'sellerRequestStep4PageLoad', {
            abTestWHYVersion: window.abTestWHYVersion
        })
            .withGA()
            .withOptimizely();
    }

    choosePriceRange(index) {
        let priceRanges = this.state.priceRanges;
        let lowPriceRange = priceRanges[index].low || null;
        let highPriceRange = priceRanges[index].high || null;
        const {alsoBuying} = this.props.parent.state;

        let currentStep =
            !this.props.loggedInUser && alsoBuying
                ? 'SELL_AND_BUY_CONTACT_STEP'
                : (window.SPLIT_CONTACT_FORM_STEP
                    ? 'SELL_CONTACT_FORM1' : 'SELL_CONTACT_FORM');
        if (!alsoBuying) {
            currentStep = 'SELL_HOME_TYPE';
        }

        this.props.parent.setState({
            lowRange: lowPriceRange,
            highRange: highPriceRange,
            priceRangeStr: priceRanges[index].rangeStr,
            priceRangeRank: index + 1,
            currentStep
        });
    }

    render() {
        return (
            <div className="flow-step">
                {/* Commented out in reason of https://upnest.atlassian.net/browse/UP-7684 */}
                {/* <div className="flow-step-text hidden-xs">
                <img className ="icon-desktop" src={global.imageBaseUrl + '/buysell/svg/save-with-upnest.svg'} />
                <div>UpNest home sellers save an average of {this.props.parent.state.avgSavings} on their agent commissions.</div>
            </div> */}

                <div className="flow-step-header-text">
                    <strong>How much do you think your home will sell for?</strong>
                </div>

                <div className="option-div">
                    <div id="price-ranges-div">
                        {$(this.state.priceRanges)
                            .map((index, range) => {
                                return (
                                    <div
                                        onClick={() => this.choosePriceRange(index)}
                                        className="choice-button price-range-button">
                                        <img
                                            src={global.imageBaseUrl + '/buysell/svg/price-tier' + (index + 1) + '.svg'}
                                        />
                                        <div style={{overflow: 'hidden'}}>
                                            <span className="button-text">{range.rangeStr}</span>
                                        </div>
                                    </div>
                                );
                            })
                            .get()}
                    </div>
                </div>

                <div className="flow-spacer" />

                {/* Commented out in reason of https://upnest.atlassian.net/browse/UP-7684 */}
                {/* <div className="bottom-banner">
                <div className="status-normal">
                    <div className="title"><img src={global.imageBaseUrl + '/buysell/svg/top-agents.svg'}/> Save with UpNest</div>
                    <div className="subtitle subtitle-large">UpNest home sellers save {this.props.parent.state.avgSavings} on average for their homes.</div>
                </div>
                <div className="status-normal subtitle subtitle-small">
                    UpNest home sellers save {this.props.parent.state.avgSavings} on average for their homes.
                </div>
            </div> */}
            </div>
        );
    }
}
